<div class="hero-banner-area">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="hero-banner-content">     
                    <h1>UOETSYLRA</h1>
                    <h2>Union Obreros y Empleados Tintoreros, Sombrereros y Lavaderos de la República Argentina</h2>
                    <p>Gracias por registrarse. Para acceder a los beneficios de UOETSYLRA, por favor descargue nuestra aplicación.</p>                
                
                    <div class="appstore-badges-wrapper">
                        <div class="appstore-badges-container">
                            <div class="images-container">
                                <a (click)="redirectTo('android')" href="#">
                                    <img *ngIf="isAndroid" class="google-badge" src="assets/img/appstore-badges/google-play-badge.png" alt="Google Play Badge">
                                </a>
                                <a (click)="redirectTo('ios')" href="#">
                                    <img *ngIf="isIOS" class="ios-badge" src="assets/img/appstore-badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg" alt="App Store Badge">
                                </a>
                                <div *ngIf="!isAndroid && !isIOS">
                                    <a (click)="redirectTo('android')" href="#">
                                        <img class="google-badge" src="assets/img/appstore-badges/google-play-badge.png" alt="Google Play Badge">
                                    </a>
                                    <a (click)="redirectTo('ios')" href="#">
                                        <img class="ios-badge" src="assets/img/appstore-badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg" alt="App Store Badge">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>   
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="hero-banner-image">
                    <img src="assets/img/imagendescarga.jpg" alt="image">
                </div>
            </div>
        </div>
    </div>
    <div class="banner-shape19"><img src="assets/img/banner-shape20.png" alt="image"></div>
    <div class="divider"></div>
</div>
<app-footer>